/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Error_IntegerInputs */

const vi_online_price_error_integer = /** @type {(inputs: Online_Price_Error_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá phải là số nguyên đồng (không có phần lẻ)`)
};

/**

* @param {Online_Price_Error_IntegerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_error_integer = /** @type {((inputs?: Online_Price_Error_IntegerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Error_IntegerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_error_integer(inputs)
});